import {
  Box,
  Button,
  FormControlLabel,
  makeStyles,
  Switch
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { editSwitchPosition } from 'src/store/modules/switchButton';

const useStyles = makeStyles(() => ({
  wrapper: {
    padding: '16px',
    paddingRight: '26px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#F5F5F5'
  }
}));
export default function SwitchSlidePosition() {
  const switchPosition = useSelector(
    (state: RootState) => state.switchButton.switchPosition
  );

  const dispatch = useDispatch();
  const classes = useStyles();
  const [checked, setChecked] = useState(switchPosition === 'up');
  const [position, setPosition] = useState(switchPosition);

  const handleChange = () => {
    setChecked(prev => !prev);
    const newPosition = !checked ? 'up' : 'down';
    setPosition(newPosition);
    dispatch(editSwitchPosition(newPosition));
  };
  useEffect(() => {
    setChecked(switchPosition === 'up');
    setPosition(switchPosition);
  }, [switchPosition]);
  return (
    <div>
      <Box className={classes.wrapper}>
        <span
          style={{
            fontSize: '0.875rem',
            fontWeight: 600,
            fontFamily: 'Archivo',
            letterSpacing: '0.0175rem'
          }}
        >
          SLIDE DIRECTION
        </span>
        <FormControlLabel
          control={
            <Switch checked={checked} onChange={handleChange} color="primary" />
          }
          label={position.toUpperCase()}
          labelPlacement="start"
        />
      </Box>
    </div>
  );
}
